import React, { useState, FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';

import Button from '../../../../atoms/Button';
import Form from './atoms/Form';

const Search: FC = () => {
  const [ isActive, setIsActive ] = useState( false );

  return (
    <>
      <Button ariaLabel="Search" onClick={() => setIsActive( !isActive )}>
        <FontAwesomeIcon icon={faMagnifyingGlass} />
      </Button>

      <Form isOverlay={isActive} onClose={() => setIsActive( false )} />
    </>
  );
};

export default Search;
